import { Controller } from "stimulus";

export default class extends Controller {
  copy() {
    let link = this.element.dataset.link;
    navigator.clipboard.writeText(link);
    this.element.innerHTML = "Link Copied!";
  }
}
